// tslint:disable:max-line-length

import React from 'react';

export const UtilityInfo = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M8,2.5c0.7,0,1.3,0.6,1.3,1.3S8.7,5.1,8,5.1S6.7,4.5,6.7,3.8 S7.3,2.5,8,2.5z M10.2,13.5H5.8v-1.7h1.1V8H5.8V6.3h3.3v5.5h1.1V13.5z" />
    </svg>
  );
};
